import * as React from 'react';
export const IcDth = (props: React.SVGProps<SVGSVGElement>): JSX.Element => (
  <svg
    viewBox='0 0 24 24'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path
      d='M19 3a2 2 0 00-2 2c.002.172.026.344.07.51l-3.66 3.66 1.42 1.42 3.66-3.66c.167.044.338.068.51.07a2 2 0 100-4zM7.05 5.64a1 1 0 00-1.41 0 9 9 0 1012.72 12.72 1 1 0 00.3-.7 1 1 0 00-.3-.71L7.05 5.64z'
      fill='currentColor'
    />
  </svg>
);
